import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import MainLayout from './components/MainLayout';
import ChurchLayout from './components/ChurchLayout';
import Home from './pages/Home';
import BoardList from './pages/BoardList';
import PostDetail from './pages/PostDetail';
import Login from './pages/Login';
import BibleSection from './pages/BibleSection';
import TheoSection from './pages/TheoSection';
import ColumnSection from './pages/ColumnSection';
import MyPage from './pages/MyPage';
import AdminPage from './pages/AdminPage';
import SearchResults from './pages/SearchResults';
import AboutPage from './pages/AboutPage';
import ChurchPage from './pages/ChurchPage';
import ChurchNewsPage from './pages/ChurchNewsPage';
import ChurchNewsDetailPage from './pages/ChurchNewsDetailPage';
import ChurchCommitteePage from './pages/ChurchCommitteePage';
import SeoulChurchPage from './pages/SeoulChurchPage';
import WritePage from './pages/WritePage';
import SignupStep1 from './pages/SignupStep1';
import SignupStep2 from './pages/SignupStep2';
import LatestPostsPage from './pages/LatestPostsPage';
import LatestCommentsPage from './pages/LatestCommentsPage';

function App() {
  return (
    <Router>
      <div id="bodyWrap">
        <Routes>
          {/* Church Routes - Independent Layout */}
          <Route path="/church" element={<ChurchLayout />}>
            <Route index element={<ChurchPage />} />
            <Route path="news" element={<ChurchNewsPage />} />
            <Route path="news/:id" element={<ChurchNewsDetailPage />} />
            <Route path="committee" element={<ChurchCommitteePage />} />
          </Route>

          {/* Seoul Church Routes - Independent Layout */}
          <Route path="/seoul-church" element={<ChurchLayout />}>
            <Route index element={<SeoulChurchPage />} />
          </Route>

          {/* Main Site Routes - With Header/Footer */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<SignupStep1 />} />
            <Route path="signup/step2" element={<SignupStep2 />} />
            <Route path="search" element={<SearchResults />} />
            <Route path="mypage" element={<MyPage />} />
            <Route path="admin" element={<AdminPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="write/:boardId" element={<WritePage />} />
            <Route path="bible" element={<BibleSection />} />
            <Route path="bible/:section" element={<BibleSection />} />
            <Route path="bible/:section/:postId" element={<PostDetail />} />
            <Route path="theo" element={<TheoSection />} />
            <Route path="theo/:section" element={<TheoSection />} />
            <Route path="theo/:section/:postId" element={<PostDetail />} />
            <Route path="columns" element={<ColumnSection />} />
            <Route path="columns/:columnist" element={<ColumnSection />} />
            <Route path="columns/:columnist/:postId" element={<PostDetail />} />
            <Route path="board/latest" element={<LatestPostsPage />} />
            <Route path="board/comments" element={<LatestCommentsPage />} />
            <Route path="board/:boardId" element={<BoardList />} />
            <Route path="board/:boardId/:postId" element={<PostDetail />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
